import * as React from 'react';

import { TooltipDesktop } from '@cian/ui-kit';

import * as styles from './styles.css';
import { Faq16 } from '../Faq16';

interface IMortgageCalculatorTooltipProps {
  text: React.ReactNode;
  onShow?: () => void;
}

export function MortgageCalculatorTooltip({ text, onShow }: IMortgageCalculatorTooltipProps) {
  return (
    <TooltipDesktop
      theme="black"
      placement="top"
      onOpen={onShow}
      title={
        <div className={styles['content']} data-testid="MortgageCalculatorTooltipText">
          {text}
        </div>
      }
    >
      <div className={styles['tooltip']} data-testid="MortgageCalculatorTooltip">
        <Faq16 />
      </div>
    </TooltipDesktop>
  );
}
